import { IStore } from '../index'

export const getClientDetailsValue = (state: IStore) =>
  state.clientDetailsReducer
